<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" :style="($store.state.currentLocation.state == 'TAS') ? { width: '80%' } : { width: '50%'}">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">{{ transferType == 'Receive' ? 'Inbound Transfer' : 'Stock Transfer' }}</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <!-- action="{{ url('payment') }}" -->
                        <!-- aria-label="{{ __('PaymentSubmit') }}" -->
                        <form class="action-modal">

                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                            <div class="form-section-container" :style="($store.state.currentLocation.state == 'TAS') ? { gridTemplateColumns: '2fr 9fr', width: '100%' } : { } ">
                                <div class="left-form-section-panel">
                                    <!-- SELECT DROPDOWN LOCATION -->
                                    <!-- SELECT DROPDOWN LOCATION -->
                                    <!-- SELECT DROPDOWN LOCATION -->
                                    <p v-if=" $store.state.company.type == 'warehouse'"  class="submit-button blue-button" style="display: flex;justify-content: center;align-items: center;margin-bottom: 5px" @click="openCreatedModal()">Add Warehouse</p>
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                   <Dropdown v-model="searchedLocation" :placeholder="transferType == 'Receive' ? 'Type in location to receive from': 'Type in location to send to'"
                                                    ref="location" @change="locationSelect()" @keyup="searchLocation(), showLocations()" @focus="showLocations()"
                                                  :loading="loadingLocation" :options="refinedLocations"     optionLabel="name"
                                                  :editable="true"
                                                  style="width: 14em; display: flex"/>
                                               
                                        </div>

                                    <div >
                                        <p style="text-align: left">Notes <span v-if="$store.state.currentLocation.state == 'TAS'" style="font-size: 10px; color:red">*</span></p>
                                        <textarea name="notes" id="note-modal" cols="44" rows="16"
                                            placeholder="Please enter notes here..."
                                            style="border-top-left-radius: 0px; border-top-right-radius: 0px; width: 100%"
                                            v-model="form.submit.notes"></textarea>
                                    </div>
                                  </div>
                                <div class="right-form-section-panel">
                                    <!-- BEFORE THEY CHOOSE IMPREST OR PATIENT OWNED MEDS -->
                                    <!-- BEFORE THEY CHOOSE IMPREST OR PATIENT OWNED MEDS -->
                                    <div v-if="patient && patient.personal_information && patient.regulatory_information"
                                        class="individual-patient-container">

                                        <div class="patient-result-info">
                                            <p><b>Name:</b> {{ patient.personal_information.first_name }}
                                                {{ patient.personal_information.last_name }}</p>
                                            <p
                                                v-if='patient.regulatory_information && patient.regulatory_information.length'>
                                                <b>{{ patient.regulatory_information &&
                                                        patient.regulatory_information.length ?
                                                        patient.regulatory_information[0].regulatory_type : ''
                                                }}:</b>
                                                {{ patient.regulatory_information &&
                                                        patient.regulatory_information.length ?
                                                        patient.regulatory_information[0].data : ''
                                                }}</p>
                                            <p><b>DOB:</b> {{ patient.personal_information &&
                                                    patient.personal_information.dob ? patient.personal_information.dob :
                                                    'N/A'
                                            }}</p>
                                            <p><b>Location:</b> {{ patient.physical_location &&
                                                    patient.physical_location.location ?
                                                    patient.physical_location.location.name : ''
                                            }}</p>
                                        </div>
                                    </div>

                                    <div v-if="patient">
                                        <div style="display: flex; margin-bottom: 10px;" :style="!selectedPrescriber ? {alignItems: 'flex-end'}:{alignItems: 'center'}">
                                            <div v-if="!selectedPrescriber"
                                                class="text-search-container search-container text-field"
                                                style="display: flex; flex-direction: column; margin-top: 0.25em; margin-right: 20px;  position: relative;">
                                                <label for="first_name"
                                                    style="text-align: left; padding-left: 10px">Search for
                                                    Prescriber</label>
                                                <input v-model="gp" v-on:keyup="debounceGpSearch(gp)" @keyup.enter="debounceGpSearch.clear(), gpSearch(gp)"
                                                    placeholder="Enter Prescriber No. or Name"
                                                    style="position: relative; border: 3px solid rgb(202, 202, 202); background-color: white;" />
                                                <div class="drug-search-result-container" v-if="gp"
                                                    style="position: absolute; margin-top: 55px; background-color: white; width: 20em; border: 2px solid #f6f6f6; z-index:9">
                                                    <p class="drug-search-result"
                                                        style="text-align: left; padding-left: 20px; cursor:pointer"
                                                        v-for="(item, index) in prescriberResults" :key="index"
                                                        @click="selectPrescriber(item)">{{ item.regulatory_numbers.length
                                                                ? item.regulatory_numbers[0].data : 'Reference only'
                                                        }} - {{ item.first_name }}
                                                        {{ item.last_name }}</p>
                                                </div>
                                                
                                            </div>
                                            <div v-if="!selectedPrescriber" style="margin-bottom: 2px;">
                                                <p class="blue-button" style="margin: 0; font-size: 1em;" @click="displayReferencePrescriberModal = true">Create prescriber</p>
                                            </div>
                                            <div v-if="selectedPrescriber"
                                                style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 2em; margin-right: 15px;">
                                                <p style="font-size: 0.9em; text-align: left;"><b>Prescriber:</b>
                                                    {{ selectedPrescriber.first_name }} {{ selectedPrescriber.last_name }}
                                                </p>
                                                <p style="font-size: 0.9em" v-if="selectedPrescriber.prescriber_no"><b>Prescriber Number:
                                                    </b>{{ selectedPrescriber.prescriber_no }}</p>
                                            </div>
                                            <p style="text-align: left;  cursor:pointer; width: fit-content;
                                        border-bottom: 1px solid grey; margin-top: 0; height: fit-content"
                                                v-if="selectedPrescriber.uuid" @click="changePrescriber()">Change
                                                Prescriber</p>
                                        </div>
                                    </div>

                                     <div v-if="($store.state.currentLocation?.facility?.medication_movement_default === 2) && !patient" style="margin-bottom: 10px;">
                                        <p class="submit-button blue-button" @click="displayPatientSearchModal = true" style="display: inline-block; width: auto; padding: 10px 20px; cursor: pointer;">
                                            Search {{ $resident({ capitalize: true }) }}
                                        </p>
                                    </div>

                                     <div v-if="(!$store.state.currentLocation?.facility?.medication_movement_default || $store.state.currentLocation?.facility?.medication_movement_default === 0) && (!imprest_pom || (imprest_pom === 'pom' && !patient))">
                                         <p
                                             style="margin: 0; padding: 0; padding-bottom: 10px; font-size: 0.95em; text-align: left;">
                                             Please select whether this is imprest/emergency meds/ward stock or {{ $resident({ lowercase: true }) }} medication.</p>
                                         <div class="right-form-section-drug-entry">
                                             <div class="pom-imprest-select">
                                                 <p @click="() => { imprest_pom = 'pom'; displayPatientSearchModal = true }"
                                                     class="pom-imprest-choice-button"
                                                     v-bind:class="[imprest_pom == 'pom' ? 'active-select-filter' : '']">
                                                     {{ $resident({ capitalize: true }) }} Medication</p>
 
                                                 <p @click="() => { imprest_pom = 'imprest'; }"
                                                     class="pom-imprest-choice-button"
                                                     v-bind:class="[imprest_pom == 'imprest' ? 'active-select-filter' : '']"
                                                    >
                                                     Imprest/Emergency Meds/Ward Stock</p>
 
                                             </div>
                                         </div>
                                     </div>

                                     <div v-if="imprest_pom === 'pom' && !patient" class="resident-help-note">
                                         Before handling stock, please choose the {{ $resident({ lowercase: true }) }} it belongs to.
                                     </div>

                                    <!-- AFTER THEY CHOOSE IMPREST OR PATIENT OWNED MEDS -->
                                    <!-- <div v-if="imprest_pom == 'imprest' || (patient && transferType != 'Send')"
                                        class="right-form-section-drug-entry">
                                        <div style="width: 40%;">
                                            <input v-model="stock" placeholder="Select Stock"
                                                style="position: relative; width:100%" />
                                        </div>

                                        <input v-model="qty" type="number" placeholder="Enter quantity"
                                            style="position: relative; width: 40%" />
                                        <p class="submit-button blue-button"
                                            @click="() => { if (qty) { checkAndAddStock(stock) } }">Add</p>
                                    </div> -->

                                    <!-- PATIENT MEDICATION SEARCH -->
                                    <div style="display: flex; align-items: center; margin-bottom: 10px" v-if="((imprest_pom == 'imprest' || (imprest_pom == 'pom' && patient)) && transferType == 'Receive')">
                                        <SelectButton style="display: flex; height: 38px" v-model="drugSearchFilter" :options="filteredSearchTypes" optionLabel="name" optionValue="value" @click="clearDrugSearchedName" />
                                    </div>
                                    <div class="right-form-section-drug-entry" v-if="patient && transferType != 'Receive'">
                                        <div style="width: 100%; margin-right: 10px">
                                            <Dropdown
                                                id="pom-select"
                                                v-model="stock"
                                                ref="medPom"
                                                @change="changeStock()"
                                                :loading="loadingDrugs"
                                                :options="filteredPatientMeds"
                                                optionLabel="full_name"
                                                optionDisabled="disabled"
                                                :editable="true"
                                                :emptyMessage="stockPickerEmptyMessage(stock, `No medications held for this ${$resident({ lowercase: true })}.`)"
                                                style="width: 100% !important; display: flex"
                                                placeholder="Select Medication"
                                            />
                                        </div>

                                        <input v-model="qty" min="0" type="number" placeholder="Quantity" style="position: relative; width: 20%; margin-right: 10px;" />
                                        <p class="submit-button blue-button" @click="() => { if (qty) { aliasSelect(stock) } }">Add</p>
                                    </div>

                                    <!-- <div v-if="transferType == 'Receive'">
                                        <div class="drug-variances-container" style="display: flex; height: fit-content"
                                            v-show='refinedDrugs && refinedDrugs.length'>
                                            <p style="padding: 3px 10px; margin-right: 5px;">Select stock: </p>
                                            <p v-for="(item, index) in refinedDrugs" :key="index"
                                                @click="aliasSelect(item)"
                                                style="padding: 3px 10px; height: fit-content; margin-right: 10px; border-radius: 8px; border: 2px solid green; cursor: pointer">
                                                {{ item.name.slice(0, 1).toUpperCase() + item.name.slice(1) }}
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="drug-variances-container" style="display: flex; height: fit-content"
                                            v-if='refinedDrugs && refinedDrugs.length'>
                                            <p style="padding: 3px 10px; margin-right: 5px;">Select stock: </p>
                                            <p v-for="(item, index) in refinedDrugs" :key="index"
                                                @click="aliasSelect(item)"
                                                style="padding: 3px 10px; height: fit-content; margin-right: 10px; border-radius: 8px; border: 2px solid green; cursor: pointer">
                                                {{ item.alias.name }} <span style="font-weight: bold">In Stock:
                                                    {{ item.qty_left }}</span>
                                            </p>
                                        </div>
                                        <div v-if="Array.isArray(refinedDrugs) && refinedDrugs.length == 0">
                                            <p style="font-size: 1em;">No stock found for that item.</p>
                                        </div>
                                    </div> -->

                                    <!-- MED SELECT DROPDOWN -->
                                    <!-- MED SELECT DROPDOWN -->
                                    <!-- MED SELECT DROPDOWN -->
                                     <div class="right-form-section-drug-entry" v-if="(imprest_pom == 'imprest' && !checkItemBoxView) || (patient && transferType != 'Send') && !checkItemBoxView">
                                        <div style="display: flex; align-items: center; width:100%" >
                                            <!-- <Dropdown v-model="stock" ref="med" @change="drugSelect(stock), show()" @keyup="searchDrugs(stock), show()" :loading="loadingDrugs" :options="drugList" optionLabel="full_name" :editable="true"
                                            style="width: 25em; display: flex" optionDisabled="disabled" placeholder="Type medication name here"/> -->
                                            <Dropdown
                                                 id="transfer-med-search"
                                                 v-model="stock"
                                                 ref="med"
                                                 @change="drugSelect(stock)" @keyup="filteredDrugSearch(stock, $event)"
                                                 @focus="onDrugFocus"
                                                 :loading="loadingDrugs"
                                                 :options="drugList"
                                                 optionLabel="full_name"
                                                 optionDisabled="disabled"
                                                 :editable="true"
                                                 :emptyMessage="drugPickerEmptyMessage"
                                                 style="width: 100% !important; display: flex" placeholder="Select Medication"
                                             />
                                        </div>
                                        <BatchSelect :stockItem="selectedDrug.full_item" v-model="selectedBatch" />
                                        <input v-model="qty" min="0" type="number" placeholder="Enter qty"
                                            style="position: relative; width: 20%" />
                                        <p :class="batchRequiredAndMissing ? 'submit-button grey-button' : 'submit-button blue-button'"
                                            @click="() => { if (qty && !batchRequiredAndMissing) { checkIfExistingItem(selectedDrug.full_item) } }">Add</p>
                                        <!-- <p class="submit-button grey-button" style="background-color: black !important"
                                        @click="() => { if (qty) { imprest_pom = ''; stock=''; qty=''; refinedDrugs = []; patient = '' } }">Cancel</p> -->
                                    </div>

                                    <div v-if="addingMed" style="display: flex; align-items: center; justify-content: center;">
                                        <span>Adding medication...</span>
                                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;"></i>
                                    </div>
                                    <div class="right-form-section-drug-container" v-if="!checkItemBoxView">
                                        <table style="border-collapse: collapse">
                                            <tr v-if="form.submit.drugs && form.submit.drugs.length > 0">
                                                <th>Drug Name, Strength, Form</th>
                                                <th v-if="showBatchColumn">Batch no.</th>
                                                <th>Stock Qty</th>
                                                <th>Supplied</th>
                                                <th v-if="$store.state.company.type !== 'warehouse'">Expected Qty</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'">Count</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'" style="width: 80px">Diff</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: center">Confirm</th>
                                                <th></th>
                                            </tr>
                                            <tr v-for="(item, index) in form.submit.drugs" :key="index"
                                                class="drug-entry-transfer">
                                                <td style="width: 50%;">
                                                    <p>{{ item.stock.slice(0, 1).toUpperCase() + item.stock.slice(1) }}</p>
                                                </td>
                                                <td v-if="showBatchColumn">
                                                    {{ item.batch_number }}
                                                </td>
                                                <td>
                                                    {{ item.qty_left ? item.qty_left : 0}}
                                                </td>
                                                <td>
                                                    {{ Number(item.qty) }}
                                                </td>
                                                <td v-if="$store.state.company.type !== 'warehouse'">
                                                    <p>{{ transferType == 'Receive' ? ((item.qty_left ? item.qty_left : 0) + Number(item.qty)) : ((item.qty_left ? item.qty_left : 0) - item.qty) }}</p>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: left">
                                                    <input style="width: 8em; background-color: white;" v-model="item.actual_balance" type="number" min="0" @input="onQtyRemainingChange(item)" />
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: left">
                                                    <span 
                                                    :class="
                                                        transferType == 'Receive' 
                                                            ? (item.actual_balance - ((item.qty_left ? item.qty_left : 0) + Number(item.qty)) >= 0) ? 'green-tag' : 's8-tag'
                                                            : (item.actual_balance - ((item.qty_left ? item.qty_left : 0) - Number(item.qty)) >= 0) ? 'green-tag' : 's8-tag'
                                                    ">
                                                        {{ 
                                                            transferType == 'Receive' 
                                                                ? item.actual_balance - ((item.qty_left ? item.qty_left : 0) + Number(item.qty)) 
                                                                : item.actual_balance - ((item.qty_left ? item.qty_left : 0) - Number(item.qty)) 
                                                        }}
                                                    </span>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: center; width: 40px">
                                                    <Checkbox :binary="true" v-model="item.balance_confirmed"/>
                                                </td>
                                                <td>
                                                    <div>
                                                        <p @click="removeDrug(index)"
                                                            class="red-close-button small-button">
                                                            <i class="pi pi-times" style='padding: 0'></i>
                                                        </p>
                                                    </div>
                                                </td>

                                            </tr>
                                        </table>
                                    </div>
                                    <div class="right-form-section-drug-container" v-if="checkItemBoxView">
                                        <table style="border-collapse: collapse">
                                            <tr v-for="(item, index) in form.submit.drugs" :key="index"
                                                class="drug-entry-transfer">
                                                <td v-if="checkItemBoxView" style="min-width: 15px;">
                                                                <div @click.stop="item.selected = !item.selected" style="cursor: pointer">
                                                                <div v-if="item.selected && (item.selected == true)" class="check-circle circle-on"></div>
                                                                <div v-else class="circle-off"></div>
                                                               </div>
                                                             </td>
                                                <td style="width: 50%;">
                                                    <p>{{ item.stock }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p>
                                                        {{ item.qty }}</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>


                            </div>



                        </form>
                    </slot>
                </div>
                <p style="color: red; font-size: 1em;margin: 0px;" v-if="errorMessage">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px" @click="closeModal">Cancel</p>
                        <!-- submitTransferAction() -->
                        <!-- <p v-if="$store.state.company.type == 'warehouse'" class="regular-button grey-button" style=" margin-right: 10px;" @click="submitTransferAndCreateNew()">{{ transferType }}
                            Transfer + New</p> -->
                        <p :class="buttonchangeUi()" style="margin-right: 10px;"
                            @click="submitTransferAction()">{{ transferType == 'Receive' ? 'Inbound Transfer' : 'Stock Transfer' }}</p>
                    </slot>
                </div>
            </div>
        </div>
        <NewLocationModal v-if="addNewLocation" @closeLocationModal="closeLocationModal"
            @addNewLocationToRefined="addNewLocationToRefined" />
        <PatientSearchModal @close="close" v-if="displayPatientSearchModal" @patient="getPatient" />
        <SignatureModal v-if="displaySignatureModal" @close="close" @isSuccessful="isSuccessful"
            :saveContext="saveContext" :payload='realSubmit' endpoint="/transfers/new-transfer" :manual_loop="imprest_pom == 'imprest'  && $store.state.currentLocation.state == 'WA'" />
        <ReferencePrescriberModal @close="close" v-if="displayReferencePrescriberModal" @prescriber="getPrescriber" />
        <AddNewSupplierModal buttonName="Warehouse" v-if="openaddNewWarehouse" @closeLocationModal="closNewModal"/>
        <SuccessModal v-if="displayErrorModal" :first_spec_line="errorMessage" :statusMessage="errorTitle" @close="closeError" />
    </div>
</template>

<script>
import SuccessModal from './SuccessModal.vue';
import NewLocationModal from '@/components/modals/NewLocationModal.vue';
import PatientSearchModal from '@/components/modals/PatientSearchModal.vue';
import ReferencePrescriberModal from '@/components/modals/ReferencePrescriberModal.vue';
import SignatureModal from '@/components/modals/SignatureModal.vue';
import AddNewSupplierModal from '@/components/modals/AddNewSupplierModal.vue';
import axios from 'axios';
import { isPickerEmpty, pickerSearchTerm, stockPickerEmptyMessage } from '@/services/pickers';
import { searchIndex, searchIndexes } from '@/services/algoliaSearch';
import { debounce, debounceSearch, DEFAULT_DEBOUNCE_MS } from '@/services/debounce';
import { decorateStockItems, decorateDrugAliases } from '@/services/stockItemDisplay';
import BatchSelect from '@/components/BatchSelect.vue';
import { filterMedicationList } from '../../services/FilterMedicationList'

export default {
    props: ['transferType','checkItemBoxView','actionParentdata'],
    components: {
        SuccessModal,
        NewLocationModal,
        SignatureModal,
        PatientSearchModal,
        ReferencePrescriberModal,
        AddNewSupplierModal,
        BatchSelect
    },
    data() {
        return {
            // Assigned in created() rather than declared in methods - see services/debounce.js.
            debounceGpSearch: null,
            debouncedDrugSearch: null,
            displayReferencePrescriberModal: false,
            addingMed: false,
            loadingLocation: false,
            loadingDrugs:false,
            justSelected: false,
            searchedLocation: '',
            imprest_pom: '',
            defaultApplied: false,
            pom: '',
            patient: '',
            gp: '',
            noStock: false,
            prescriberResults: [],
            addNew: false,
            patientMeds: [],
            prescriber: '',
            selectedPrescriber: '',
            errorMessage: '',
            errorTitle: '',
            displayErrorModal: false,
            selectedDrug:{},
            displaySignatureModal: false,
            displayPatientSearchModal: false,
            newLoc: '',
            stock: '',
            qty: null,
            location: '',
            addNewLocation: false,
            noLocationFound: false,
            refinedLocations: null,
            refinedDrugs: '',
            drugList:[],
            // The batch chosen beside the picker for the row being added, cleared once the row is on
            // the list. BatchSelect also clears it whenever the medication changes.
            selectedBatch: null,
            form: {
                submit: {
                    type: '',
                    to_from: '',
                    drugs: [],
                    notes: '',
                }
            },
            realSubmit: {
                type: '',
                to_from: '',
                drugs: [],
                notes: '',
            },
            // INFORMATION PROVIDED TO USER TO PROVIDE CONTEXT ON AUTOSAVE INFORMATION
            saveContext: {
                type: 'Transfer',
                patient: '',
                location: '',
                drugs: [],
                doubleSig: false
            },
            openaddNewWarehouse:false,
            searchTypes: [
                { name: 'All', value: 0 },
                { name: 'Brands', value: 2 },
                { name: 'Generics', value: 1 },
                { name: 'Custom', value: 3 }
            ],
            drugSearchFilter: 1,
        };
    },
    watch: {
        imprest_pom: {
            handler(newVal) {
                if (newVal === '') {
                    if (this.defaultApplied) return;
                    const movementDefault = this.$store.state.currentLocation?.facility?.medication_movement_default;
                    if (movementDefault === 1) {
                        this.imprest_pom = 'imprest';
                        this.defaultApplied = true;
                    } else if (movementDefault === 2) {
                        this.imprest_pom = 'pom';
                        this.defaultApplied = true;
                    }
                }
            },
            immediate: true
        },
        '$store.state.currentLocation': {
            handler(newLocation) {
                const drugSearchTypeDefault = newLocation?.facility?.drug_search_type_default;
                if (drugSearchTypeDefault === 1) {
                    if (this.drugSearchFilter === 0 || this.drugSearchFilter === 2) {
                        this.drugSearchFilter = 1;
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        // Receive searches the drug catalogue and Send searches what this location holds, through
        // the one picker - see searchDrugs(). An empty Receive list says nothing about the safe, so
        // it must not claim the location holds no stock.
        drugPickerEmptyMessage() {
            return stockPickerEmptyMessage(
                this.stock,
                this.transferType == 'Receive' ? 'No medications match that search.' : 'No stock held at this location.'
            );
        },
        // Show the batch column when any row actually carries a batch. This used to be keyed on the
        // company type, which meant an aged care user could not see the batch they had just chosen and
        // a warehouse user with unbatched stock got an empty column.
        showBatchColumn() {
            const rows = (this.form && this.form.submit && Array.isArray(this.form.submit.drugs)) ? this.form.submit.drugs : [];
            return rows.some(row => row && row.batch_number);
        },
        // The stock item holds batches and none has been chosen yet, so the row cannot be added. The
        // backend enforces the same thing, so this only saves the user a rejected submit.
        batchRequiredAndMissing() {
            const item = this.selectedDrug ? this.selectedDrug.full_item : null;
            const batches = (item && Array.isArray(item.batches)) ? item.batches : [];
            // The flag is checked here too, so a stale response carrying batches cannot leave Add
            // permanently disabled for a facility that has no batch dropdown to satisfy it with.
            return this.$store.getters.isBatchTrackingEnabled && batches.length > 0 && !this.selectedBatch;
        },
        filteredSearchTypes() {
            const drugSearchTypeDefault = this.$store.state.currentLocation?.facility?.drug_search_type_default;
            if (drugSearchTypeDefault === 1) {
                return [
                    { name: 'Generics', value: 1 },
                    { name: 'Custom', value: 3 }
                ];
            }
            return this.searchTypes;
        },
        // The resident's whole holding is loaded up front, so this dropdown has no server
        // side search behind it - the typed text filters the loaded list instead.
        filteredPatientMeds() {
            return filterMedicationList(this.patientMeds, this.stock);
        }
    },
    created() {
        this.debounceGpSearch = debounceSearch((query) => this.gpSearch(query));
        this.debouncedDrugSearch = debounce((searchedDrugName) => this.runDrugSearch(searchedDrugName), DEFAULT_DEBOUNCE_MS);
    },
    methods: {
        stockPickerEmptyMessage,
        getPrescriber(value){
            console.log('getprescriber function is called', value);
            if(value){
                this.selectedPrescriber = value;
                this.displayReferencePrescriberModal = false;
            }
            
        },
        showLocations(){
            console.log('HITING SAVE FUNCTION');
            if (this.justSelected) {
                this.justSelected = false;
                return;
            }
            let interval = setInterval(() => {
                console.log('HITTING INTERVAL');
                if (!this.loadingLocation && this.refinedLocations) {
                    clearInterval(interval);
                    this.$refs.location.show();
                }
            }, 100)
        },

        // Enter searches straight away; any other key waits until the user stops typing.
        filteredDrugSearch(searchedDrugName, event) {
            if (typeof searchedDrugName === 'object' && searchedDrugName !== null) {
                return;
            }

            if (event && event.key === 'Enter') {
                if (event.preventDefault) event.preventDefault();
                this.debouncedDrugSearch.clear();
                this.runDrugSearch(searchedDrugName);
            } else {
                this.debouncedDrugSearch(searchedDrugName);
            }
        },
        // Filter 3 is the company's own custom drug list, which has its own endpoint.
        runDrugSearch(searchedDrugName) {
            if (this.drugSearchFilter != 3) {
                this.searchDrugs();
            } else {
                this.customDrugSearch(searchedDrugName);
            }
        },
        getDrugOptionLabel(){
          if (this.transferType === 'Send') {
                return 'alias.generic_name'
            } else {
                return 'name';
            }
        },
        show() {
            this.$nextTick(() => {
                let dropdown = this.$refs.med;
                if (Array.isArray(dropdown)) {
                    dropdown = dropdown.find(d => d && d.$el && d.$el.isConnected) || dropdown[0];
                }
                if (dropdown && typeof dropdown.show === 'function') {
                    dropdown.show();
                    
                    const id = dropdown.$el && dropdown.$el.id;
                    if (id) {
                        setTimeout(() => {
                            const medListDropdown = document.querySelector(`#${id}_list`);
                            if (medListDropdown) {
                                medListDropdown.querySelectorAll('.p-dropdown-item.p-focus').forEach((med) => {
                                    med.classList.remove('p-focus');
                                });
                                const firstMed = medListDropdown.querySelector('.p-dropdown-item');
                                if (firstMed) {
                                    firstMed.classList.add('p-focus');
                                }
                            }
                        }, 50);
                    }
                }
            });
        },
        loadDefaultLocations() {
            this.loadingLocation = true;
            if (this.$store.state.company.type == 'warehouse') {
                const payload = {
                    location_type: [],
                    filters: {
                        party: '',
                    }
                };
                axios.post('/warehouse/retrieve-locations', payload, this.$store.state.header).then(async res => {
                    this.$store.dispatch('getRefreshToken');
                    let refined = await res.data.data;
                    this.refinedLocations = refined;
                    this.loadingLocation = false;
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                        this.$router.push('/login');
                    }
                });
            } else {
                axios.post('/get-locations', { location: '' }, this.$store.state.header).then(res => {
                    this.$store.dispatch('getRefreshToken');
                    let refined = [];
                    const currentLoc = JSON.parse(localStorage.getItem('currentLocation'));
                    const currentLocUuid = currentLoc ? currentLoc.uuid : null;
                    res.data.locations.forEach(location => {
                        if (location.uuid != currentLocUuid) {
                            refined.push(location);
                        }
                    });
                    this.refinedLocations = refined;
                    this.loadingLocation = false;
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                        this.$router.push('/login');
                    }
                });
            }
        },
        searchLocation : debounce (function(){
            if (this.searchedLocation) {
                this.loadingLocation = true;
                if (this.$store.state.company.type == 'warehouse') {
                    const payload={
                        location_type: [],
                        filters: {
                            party:this.searchedLocation,
                        }
                    }
                axios.post('/warehouse/retrieve-locations', payload , this.$store.state.header).then(async res => {
                    console.log('these are the returned locations', res.data);
                    this.$store.dispatch('getRefreshToken');
                    let refined = await res.data.data;
                    // res.data.locations.forEach(location=>{
                    //     if(location.uuid != JSON.parse(localStorage.getItem('currentLocation')).uuid){
                    //         refined.push(location);
                    //     }
                    // })
                    this.refinedLocations = refined;
                    if(this.refinedLocations.length){
                        this.$refs.location.show();
                    }

                    if (this.refinedLocations.length == 1) {
                        this.form.submit.to_from = this.refinedLocations[0].uuid;
                        this.location = this.refinedLocations[0].name;
                    }
                    this.loadingLocation = false;
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                });
                }else{
                    axios.post('/get-locations', { location: this.searchedLocation}, this.$store.state.header).then(res => {
                    
                    console.log('these are the returned locations', res.data);
                    this.$store.dispatch('getRefreshToken');
                    let refined =[];
                    res.data.locations.forEach(location=>{
                        if(location.uuid != JSON.parse(localStorage.getItem('currentLocation')).uuid){
                            refined.push(location);
                        }
                    })
                    this.refinedLocations = refined;
                    if(this.refinedLocations.length){
                        this.$refs.location.show();
                    }

                    if (this.refinedLocations.length == 1) {
                        this.form.submit.to_from = this.refinedLocations[0].uuid;
                        this.location = this.refinedLocations[0].name;
                    }
                    this.loadingLocation = false;
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                });
                }
            } else {
                this.loadDefaultLocations();
            }
        },[1000]),
        drugSelect(item) {
            if (typeof item === 'string' || !item) return;
            this.loadingDrugs = true;
            console.log('this is the drug item selected', item);
            this.selectedDrug.full_item = item;
            this.selectedDrug.drug_uuid = this.transferType == 'Send' ? item.alias.alias_id : item.alias_id;
            this.selectedDrug.full_name = item.full_name || '';
            this.selectedDrug.form = this.transferType == 'Receive' ? (item.form ? item.form[0].toUpperCase() + item.form.slice(1) : '') : (item.alias && item.alias.form ? item.alias.form[0].toUpperCase() + item.alias.form.slice(1) : '');
            this.selectedDrug.strength = `${this.transferType == 'Send' ? (item.alias ? item.alias.strength : '') : (item.strength || '')}`;
            this.selectedDrug.measurement_unit = `${this.transferType == 'Send' ? (item.alias ? item.alias.measurement_unit : '') : (item.measurement_unit || '')}`;
            
            let itemName = this.transferType == 'Send' ? (item.alias ? item.alias.name : '') : (item.name || '');
            this.selectedDrug.name = itemName ? itemName[0].toUpperCase() + itemName.slice(1) : '';
            this.selectedDrug.tags = this.transferType == 'Send' ? (item.alias ? item.alias.tags : []) : (item.tags || []);
            this.loadingDrugs = false;
        },
        // searchDrugs() {
            
        //     if(this.stock){
        //         this.loadingDrugs = true;
        //         axios.post('/get-drug-aliases', { drug: this.stock, generics: parseInt(this.drugSearchFilter) }, this.$store.state.header).then(res => {
        //             console.log('this is the res data', res.data);
        //             res.data.drug_aliases.forEach(item=>{
        //                 item.full_name = `(${item.generic_name}) ${item.name}`
        //             })
        //             this.drugList = res.data.drug_aliases;

        //             this.drugSelect(this.drugList[0]);
        //             this.loadingDrugs = false;
        //             // document.getElementsByClassName('p-dropdown-panel')[0].style.display = 'block';
        //         }).catch(err => {
        //             console.log('this is the err', err);
        //             this.loadingDrugs = false;
        //             if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
        //                 console.log('yes, it does include expired')
        //                 this.$router.push('/login');
        //             }
        //         })
        //     }
        // },
        openCreatedModal() {
                this.openaddNewWarehouse = true
        },
        locationSelect() {
            this.location = this.searchedLocation.name;
            this.form.submit.to_from = this.searchedLocation.uuid;
            this.justSelected = true;
            setTimeout(() => {
                this.justSelected = false;
            }, 200);
            this.$refs.location.hide();
        },
        changeStock() {
            // No autofill of quantity from stock for normal movements
        },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
        },
        gpSearch(prescriber) {
            // let results = [];
            this.prescriberResults = [];
            console.log('this is the drug', prescriber);
            searchIndexes(this.$store.state, [
                { "indexName": `${this.$store.state.subdomain}_prescribers`, "params":  `query=${prescriber}` },
                { "indexName": `${this.$store.state.subdomain}_prescriber_references`, "params":  `query=${prescriber}&facetFilters=company_uuid:${this.$store.state.company.uuid}` },
            ]).then(res => {
                    console.log('this is the algolia res', res.data.results);
                    res.data.results.forEach(indexResult=>{
                        console.log('these are the results for this particular index', indexResult);
                        if(indexResult.hits.length){

                            // results.push(indexResult.hits);
                            indexResult.hits.forEach(hit=>{
                                this.prescriberResults.push(hit);
                            })
                            console.log('this is the local results varaible', this.prescriberResults);
                        }
                        
                    })
                    // this.prescriberResults = res.data.hits;
                    // state.commit('setDrugNames', res.data.hits);
                })
                // Algolia gives up after 5s per host (see services/algoliaSearch.js). On a bad
                // connection that rejection had nothing catching it; the dropdown just stays empty.
                .catch(err => {
                    console.log('prescriber search failed', err);
                })

        },
        isSuccessful(value) {
            if (value) {
                console.log('IS SUCCESSFUL!');
                // if (this.$route.name == 'Drug Register') {
                //     console.log('loading the drug register stuff');
                //     this.$store.dispatch('getDrugRegister', {
                //         sort_direction: 'desc',
                //         col: 'created_at',
                //         page: 1,
                //         filters: {
                //             transaction_id: '',
                //             to_from: '',
                //             entered_by: '',
                //             date: {
                //                 start: '',
                //                 end: ''
                //             },
                //             drug: '',
                //             imprest_only: false
                //         }
                //     });
                // } else if (this.$route.name == 'Stock') {
                //     console.log('loading the stock stuff');
                // } else
                 if (this.$route.name == 'Transfers') {
                    console.log('loading the transfer stuff');
                    this.$store.dispatch('getTransfers', {
                        sort_direction: 'desc',
                        col: 'created_at',
                        page: 1,
                        location: this.$store.state.uuid,
                        filters: {
                            status: ['pending', 'reversed', 'rejected', 'completed'],
                            completed_by: '',
                            location: '',
                            type: ['send', 'receive'],
                            date: {
                                start: '',
                                end: ''
                            },
                        }
                    });
                } 
                // else if (this.$route.name == 'Stock Take') {
                //     console.log('loading the stock take version stuff');
                //     this.$store.dispatch('getStockTake', {
                //         sort_direction: '',
                //         col: '',
                //         page: 1,
                //         location: this.$store.state.uuid,
                //         filters: {
                //             tags: ["s8"],
                //             show_inactive: false,
                //             in_stock: false,
                //             date: {
                //                 start: '',
                //                 end: ''
                //             },
                //             product_name: '',
                //         }
                //     });
                // }

                if (this.addNew) {
                    this.form.submit.drugs = [];
                    this.stock = '';
                    this.defaultApplied = false;
                    this.imprest_pom = '';
                    this.patient = '';
                    this.patient_uuid = '';
                    this.prescriber_uuid = '';
                    this.selectedPrescriber = '';
                    this.refinedDrugs = '';
                } else {
                    this.$emit('close', true,'success');
                }
            }
        },
        close(value) {
            if (value) {
                this.displaySignatureModal = false;
                this.displayReferencePrescriberModal = false;
                // this.dual = false;
                if (this.imprest_pom != 'imprest' && !this.patient) {
                    this.displayPatientSearchModal = false;
                    this.imprest_pom = '';
                }
            }
        },
        closeLocationModal(value) {
            if (value) {
                this.addNewLocation = false;
            }
        },
        closNewModal(){
            this.openaddNewWarehouse = false
        },
        addNewLocationToRefined(value) {
            this.form.submit.to_from = value.uuid;
            this.refinedLocations = [value];
            console.log('RECEIVING FROM ADD LOCATION', value);
            this.location = value.name;
        },
        checkIfExistingItem(item){
            let exit = false;
            // The batch is part of what makes a row, not just the drug. Two batches of the same
            // medication are two rows - matching on the drug alone overwrote the first row's
            // quantity while it kept the first batch, so the stock came off the wrong batch.
            const batchUuid = this.selectedBatch ? this.selectedBatch.uuid : null;
            if(this.form.submit.drugs.length){
                this.form.submit.drugs.forEach(drugItem => {
                    console.log('LOOPING THROUGH LIST', drugItem, item);
                    if (((item.uuid == drugItem.drug) || (item.alias_id == drugItem.drug)) && ((drugItem.batch_uuid ?? null) === batchUuid) && !exit ) {
                        console.log('HIT A MATCH', drugItem);
                        drugItem.qty = this.qty;
                        exit = true;
                    } 
                })
                if (!exit) {
                    this.aliasSelect(item);
                }
            } else{
                this.aliasSelect(item);
            }
        }, 
        onQtyRemainingChange(item) {
            console.log('Quantity remaining changed:', item.actual_balance);
            item.balance_confirmed = (Number(item.actual_balance) == (Number(item.qty_left) - Number(item.qty))) ? true : false;
        },
        aliasSelect(item) {
            console.log('this is the alias select item', item);
            this.addingMed = true;
            let quantity = item.quantity !== undefined ? item.quantity : item.qty_left;
                    if (this.transferType == 'Receive') {
                        if ((this.imprest_pom == 'imprest' || this.imprest_pom == '')) {
                            // An inbound transfer brings stock in from a location outside the
                            // application: the source is a pass-through and the stock is created as
                            // it transfers through (see TransferController::createTransfer, which
                            // creates the source stock register on the fly). The destination's
                            // current holding is therefore display-only - it must never clamp or
                            // gate the received quantity. Clamping to qty_left silently recorded a
                            // short receipt, and 0 on hand recorded nothing at all.
                            axios.post('/get-stock', { alias_id: item.alias_id ?? item.uuid, location_id: this.$store.state.uuid }, this.$store.state.header).then(res => {
                                this.form.submit.drugs.unshift({
                                    tags: item.tags,
                                    stock: item.name,
                                    batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                                    form: item.form,
                                    drug: item.alias_id || item.uuid,
                                    entered_qty: this.qty,
                                    qty_left: res.data.qty_left,
                                    qty: Number(this.qty),
                                    balance_confirmed: true,
                                    actual_balance: Number(res.data.qty_left) + Number(this.qty),
                                });

                                // this.form.submit.drugs.unshift({tags: item.alias.tags,stock:res.data.drug_alias, 'drug': item.alias_id, form: res.data.form, qty: this.qty <= Number(item.quantity) ? this.qty : Number(item.quantity), qty_left: res.data.qty_left});
                                this.$store.dispatch('getRefreshToken');
                                this.qty = null;
                                this.selectedBatch = null;
                                this.stock = '';
                                this.refinedDrugs = [];
                                this.selectedDrug = {};
                                this.noStock = false;
                                this.addingMed = false;
                            }).catch(err => {
                                // /get-stock 404s when the destination holds none of this drug,
                                // which is the normal case for an inbound transfer. Add the row
                                // regardless - the lookup is informational only. Note qty must stay
                                // numeric: it previously held the string 'None in stock.', which
                                // rendered as NaN in the Supplied/Expected columns and was then
                                // dropped by the `item.qty > 0` filter on submit, posting an empty
                                // drugs array that the API rejected as invalid.
                                console.log('destination stock lookup failed, treating as none on hand', err.response?.data);
                                this.form.submit.drugs.unshift({
                                    tags: item.tags,
                                    stock: item.name,
                                    batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                                    drug: item.alias_id || item.uuid,
                                    form: item.form,
                                    entered_qty: this.qty,
                                    qty: Number(this.qty),
                                    qty_left: 0,
                                    balance_confirmed: true,
                                    actual_balance: Number(this.qty),
                                });
                                this.qty = null;
                                this.selectedBatch = null;
                                this.stock = '';
                                this.refinedDrugs = [];
                                this.selectedDrug = {};
                                this.addingMed = false;
                            })
                        } else {
                            console.log('hitting else condition')
                            if (this.transferType == 'Receive') {
                                // qty_left is absent on a drug-search hit (it is not a stock item),
                                // so default it rather than letting it poison actual_balance as NaN.
                                const onHand = Number(item.qty_left) || 0;
                                this.form.submit.drugs.unshift({
                                    tags: item.tags,
                                    stock: item.name,
                                    batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                                    form: item.form,
                                    drug: item.alias_id || item.uuid,
                                    entered_qty: this.qty,
                                    qty_left: onHand,
                                    qty: Number(this.qty),
                                    balance_confirmed: true,
                                    actual_balance: onHand + Number(this.qty),
                                });

                                // this.form.submit.drugs.unshift({tags: item.alias.tags,stock:res.data.drug_alias, 'drug': item.alias_id, form: res.data.form, qty: this.qty <= Number(item.quantity) ? this.qty : Number(item.quantity), qty_left: res.data.qty_left});
                                this.$store.dispatch('getRefreshToken');
                                this.qty = null;
                                this.selectedBatch = null;
                                this.stock = '';
                                this.refinedDrugs = [];
                                this.selectedDrug = {};
                                this.addingMed = false;
                                this.noStock = false
                            } else {
                                this.form.submit.drugs.unshift({ 
                                    tags: item.alias.tags, 
                                    stock: item.alias.name,
                                    batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                                    form: item.alias.form, 
                                    qty_left: quantity, 
                                    drug: item.alias.alias_id, 
                                    entered_qty: this.qty, 
                                    qty: this.qty <= Number(quantity) ? this.qty : Number(quantity),
                                    balance_confirmed: true, 
                                    actual_balance: Number(this.qty),
                                });
                                this.selectedDrug = {};
                                this.stock = '';
                                this.addingMed = false;
                            }
                            // console.log('this is the quantity else condition', this.qty, Number(res.data.qty_left), this.qty > Number(res.data.qty_left))

                        }
                    } else {
                        if ((this.imprest_pom == 'imprest' || this.imprest_pom == '')) {
                            this.form.submit.drugs.unshift({ 
                                tags: item.alias.tags, 
                                stock: item.alias.name,
                                batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                                batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                                drug: item.uuid, 
                                form: item.alias.form, 
                                qty: this.qty, 
                                qty_left: item.qty_left,
                                balance_confirmed: true, 
                                actual_balance: Number(item.qty_left) - Number(this.qty),
                            });
                            this.qty = null;
                            this.selectedBatch = null;
                            this.refinedDrugs = '';
                            this.stock = '';
                            this.selectedDrug = {};
                            this.noStock = false;
                            this.addingMed = false;
                        } else {
                            this.form.submit.drugs.unshift({ 
                                tags: item.alias.tags, 
                                stock: item.alias.name,
                                batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                                batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                                form: item.alias.form, 
                                qty_left: quantity, 
                                drug: item.uuid, 
                                qty: this.qty <= Number(quantity) ? this.qty : Number(quantity),
                                balance_confirmed: true, 
                                actual_balance: Number(quantity) - Number(this.qty <= Number(quantity) ? this.qty : Number(quantity)),
                            });
                            this.selectedDrug = {};
                            this.stock = '';
                            this.addingMed = false;
                        }
                    }
        },
        algoliaDrugSearch(searchedDrugName) {
            this.loadingDrugs = true;
            this.drugList = [];
            // Only typed text is a search; a held selection has nothing left to look up.
            const searchName = pickerSearchTerm(searchedDrugName);

            // set flags for all/brands/generic
            let searchType = ``;
            if (this.drugSearchFilter == 1) {
                searchType = `&facetFilters=is_generic:true`
            }

            if (this.drugSearchFilter == 2) {
                searchType = `&facetFilters=is_generic:false`
            }

            searchIndex(this.$store.state, `${this.$store.state.subdomain}_drugs`, `typoTolerance=false&query=${searchName}${searchType}${this.$store.state.company.type == 'warehouse' ? "&facetFilters=deprecated:false" : ""}`)
            .then(async res => {
                console.log('this is the algolia res', res.data.hits);
                this.$store.dispatch('getRefreshToken');
                // Algolia hits are flat drug records, so give them the { alias } shape the shared
                // decorator expects. There is no batch behind an index hit, only an aggregate qty.
                res.data.hits.forEach(item => {
                    item.alias = {
                        alias_id: item.alias_id,
                        name: item.name,
                        generic_name: item.generic_name,
                        form: item.form,
                        tags: item.tags,
                        strength: item.strength,
                    };
                })
                this.drugList = decorateStockItems(res.data.hits);
                this.errorMessage = '';
                this.loadingDrugs = false;
                this.show();
            })
            .catch(err => {
                this.loadingDrugs = false;
                console.error(err);
            })
        },
        onDrugFocus() {
            if (this.imprest_pom === 'imprest' && this.transferType === 'Send') {
                if (isPickerEmpty(this.stock)) {
                    this.searchDrugs(true);
                    this.show();
                }
            }
        },
        searchDrugs(fetchDefault = false) {
            // Only typed text is a search; a held selection has nothing left to look up.
            const searchTerm = pickerSearchTerm(this.stock);
            if (searchTerm || fetchDefault) {
                this.loadingDrugs = true;
                if (this.transferType == 'Receive') {
                    if (this.$store.state.company.type == 'warehouse') {
                        this.algoliaDrugSearch(searchTerm)
                    }else{
                        axios.post('/get-drug-aliases', { drug: searchTerm, generics: this.drugSearchFilter }, this.$store.state.header).then(res => {
                            console.log('this is the res data', res.data);
                            this.$store.dispatch('getRefreshToken');
                            this.drugList = decorateDrugAliases(res.data.drug_aliases);
                            this.drugList.forEach(item => {
                                item.qty_left = 0;
                                const stockMed = this.patientMeds.find(med => med.alias.alias_id === item.alias_id);
                                if (stockMed) {
                                    item.qty_left = stockMed.quantity;
                                }
                            })
                            this.errorMessage = '';
                            this.loadingDrugs = false;
                            this.show();
                        })
                        .catch(err => {
                            this.errorMessage = err.response.data;
                            console.log('err', err.response.data);
                            this.loadingDrugs = false;
                        })
                    }
                } else {
                    axios.post('/get-stock-items', { drug: searchTerm, patient_id: this.patient ? this.patient.uuid : null }, this.$store.state.header).then(res => {
                        console.log('this is the res data getstockitems', res.data);
                        this.$store.dispatch('getRefreshToken');
                        this.drugList = decorateStockItems(res.data, { showBatch: this.$store.state.company.type !== 'aged care' });
                        this.errorMessage = '';
                        this.loadingDrugs = false;
                        this.show();
                    })
                    .catch(err => {
                        if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                            console.log('yes, it does include expired')
                            this.$router.push('/login');
                        }
                        console.log('this is the transfer stock items error', err.response.data);
                        this.errorMessage = err.response.data;
                        this.loadingDrugs = false;
                    })
                }
            }
        },
        clearDrugSearchedName() {
            this.stock = "";
            this.drugList = [];
        },
        customDrugSearch(searchedDrugName) {
            this.loadingDrugs = true;
            axios.post(`/company-drugs`, {filter:{tags:[],name:searchedDrugName},page:1, custom_only: true }, this.$store.state.header)
            .then(res => {
                console.log('this is the company owned drug res', res.data.drugs);
                res.data.drugs.forEach(item=>{
                    const alias = {
                        alias_id: item.alias_id,
                        name: item.name,
                        form: item.form,
                        tags: item.tags,
                        strength: item.strength,
                    };

                    item.alias = alias
                })
                this.drugList = decorateDrugAliases(res.data.drugs);
                this.loadingDrugs = false;
                this.show();
            })
            .catch(err => {
                this.loadingDrugs = false;
                console.error(err);
            })
        },
        removeDrug(index) {
            console.log('this is the index', index, this.form.submit.drugs);
            this.form.submit.drugs.splice(index, 1);
        },
        closeError(value) {
            if (value) {
                this.errorTitle = '';
                this.errorMessage = '';
                this.displayErrorModal = false;
            }
        },
        submitTransferAction() {
            if(this.$store.state.currentLocation.state == 'TAS') {
                if (this.form.submit.notes.trim() == '') {
                    this.displayErrorModal = true;
                    this.errorTitle = 'Error';
                    this.errorMessage = 'Notes is required';
                    return;
                }
            }

            let newDrugSub = [];
            let autoDrugs = [];
            this.addNew = false;
            if (this.checkItemBoxView) {
                const filterdata = this.form.submit.drugs.filter((item)=> item?.selected && item.selected === true)
               filterdata.forEach(item => {
                let p = {
                    batch_uuid: item?.batch_uuid,
                    drug: item.drug,
                    alias: item.stock,
                    qty: Number(item.qty),
                    tags: item?.tags,
                    batch_item_id:item?.batch_item_id
                }
                let ad = {
                    drug: item.stock,
                    qty: Number(item.qty),
                    tags: item?.tags,
                    batch_item_id:item?.batch_item_id,
                    batch_uuid: item?.batch_uuid,
                }
                autoDrugs.push(ad);
                // if(item.tags && item.tags.length){
                //     this.dual = true;
                // }
                if (item.qty > 0) {
                    newDrugSub.push(p);
                }
            });
            }else{
                this.form.submit.drugs.forEach(item => {
                    let p = {
                        drug: item.drug,
                        alias: item.stock,
                        qty: Number(item.qty),
                        tags: item.tags,
                        balance_confirmed: item.balance_confirmed,
                        actual_balance: item.actual_balance,
                        // The batch chosen beside the picker. Null where the stock item holds none;
                        // BatchSelectionRule rejects the row if it holds batches and this is missing.
                        batch_uuid: item?.batch_uuid ?? null,
                    }
                    let ad = {
                        drug: item.stock,
                        qty: Number(item.qty),
                        tags: item.tags
                    }
                    autoDrugs.push(ad);
                    // if(item.tags && item.tags.length){
                    //     this.dual = true;
                    // }
                    if (item.qty > 0) {
                        newDrugSub.push(p);
                    }
                });
            }
            this.realSubmit = {
                type: this.transferType === 'Receive' ? 'receive' : 'send',
                to_from: this.form.submit.to_from,
                drugs: this.form.submit.drugs,
                notes: this.form.submit.notes,

                prescriber_uuid: this.selectedPrescriber ? this.selectedPrescriber.uuid : '',
                patient_uuid: this.patient ? this.patient.uuid : ''
            };
            this.saveContext = {
                drugs: autoDrugs,
                location: JSON.parse(localStorage.getItem('currentLocation')).name,
                patient: this.patient ? `${this.patient.personal_information.first_name} ${this.patient.personal_information.last_name}` : 'Imprest/Emergency Stock',
                supplemental: this.patient && this.patient.regulatory_information.length ? `${this.patient.regulatory_information[0].regulatory_type}: ${this.patient.regulatory_information[0].data}` : ``,
                doubleSig: true,
                type: `Transfer ${this.transferType == 'Receive' ? 'In' : 'Out'}`
            }

            this.realSubmit.drugs = newDrugSub;
            console.log('this is the form to submit', this.form, this.saveContext);
            console.log(this.form.submit.drugs.length && this.form.submit.type && this.form.submit.to_from)
            if (this.checkItemBoxView) {
                if (this.realSubmit.drugs?.length > 0 && this.form.submit.to_from && this.realSubmit.type) {
                    this.displaySignatureModal = true;
                    this.errorMessage = '';
                } else {
                    this.errorMessage = 'Drugs and a location is required.'
                }
            }else{
                // Guard on the payload we are about to post, not on form.submit.drugs. Rows are
                // dropped from newDrugSub by the `item.qty > 0` filter above, so a non-empty table
                // could still produce an empty drugs array - which the API correctly rejected as
                // invalid, surfacing as an opaque "given data was invalid" to the user.
                if (this.realSubmit.drugs?.length > 0 && this.realSubmit.type && this.form.submit.to_from) {
                    this.displaySignatureModal = true;
                    this.errorMessage = '';
                } else if (!this.realSubmit.drugs?.length && this.form.submit.drugs.length) {
                    this.errorMessage = 'Every medication needs a quantity greater than zero.'
                } else {
                    this.errorMessage = 'Drugs and a location is required.'
                }
            }
        },
        buttonchangeUi(){
        if (this.$store.state.company.type == 'warehouse') {
            if (this.checkItemBoxView) {
                    const selectData2 = this.form.submit.drugs.filter((item)=> item?.selected && item.selected === true)
                    if (selectData2?.length > 0 && this.form.submit.to_from && this.form.submit.to_from) {
                        return 'regular-button green-button'
                    } else {
                        return 'regular-button grey-button'
                    }
                }else{
                    if (this.form.submit.to_from && this.form.submit.drugs?.length > 0) {
                        return 'regular-button green-button'
                    } else {
                        return 'regular-button grey-button'
                    }
                }
        }else{
            return 'regular-button green-button'
        }
        },
        selectPrescriber(prescriber) {
            console.log('this is the selected result', this.nonGP);
            this.prescriberResults = [];
            this.selectedPrescriber = {
                prescriber_no: prescriber.regulatory_numbers.length ? prescriber.regulatory_numbers[0].data : '',
                uuid: prescriber.uuid,
                first_name: prescriber.first_name,
                last_name: prescriber.last_name,
                phone: prescriber.phone,
                after_hours: prescriber.after_hours,
                address: prescriber.address,
                email: prescriber.email,
                fax: prescriber.fax,
                primary_gp: false
            }
        },
        changePrescriber() {
            this.selectedPrescriber = '';
            this.gp = '';
        },
        getPatient(value) {
            if (value) {
                this.patient = value;
                this.displayPatientSearchModal = false;
                // {uuid: this.patient.uuid}

                axios.post(`/get-stock-items`, { drug: '', patient_id: this.patient.uuid }, this.$store.state.header).then(res => {
                    console.log('this is the patient register', res);
                    this.patientMeds = decorateStockItems(res.data);
                })
            }
        },
        submitTransferAndCreateNew() {
            this.realSubmit = {
                type: this.form.submit.type.toLowerCase(),
                to_from: this.form.submit.to_from,
                drugs: this.form.submit.drugs,
                notes: this.form.submit.notes,
                prescriber_uuid: this.selectedPrescriber ? this.selectedPrescriber.uuid : '',
                patient_uuid: this.patient ? this.patient.uuid : '',
            };
            if (this.form.submit.drugs.length && this.form.submit.type && this.form.submit.to_from) {
                this.addNew = true;
                this.form.submit.type = this.transferType;
                console.log('this is the form to submit', this.form);
                this.form.submit.drugs.forEach(drug => {
                    delete drug.qty_left;
                    drug.qty = Number(drug.qty);
                })
                // this.$store.dispatch('submitDelivery',this.form);
                // this.refinedLocations = [];

                this.displaySignatureModal = true;
                this.errorMessage = '';
            } else {
                this.errorMessage = 'Drugs and location are required.'
            }
        },
    },
    mounted() {
        if (this.actionParentdata?.items) {
            if (this.actionParentdata?.items?.length > 0) {
                this.form.submit.drugs = this.actionParentdata?.items
            }
        }
        this.form.submit.type = this.transferType;
        this.loadDefaultLocations();
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

.right-form-section-drug-container {
    height: 200px;
    overflow-y: auto;
}

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
    // td:first-child{
    //     border-top-left-radius: 12px;
    //     border-bottom-left-radius: 12px;
    // }
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}
</style>